import { PostBodyUserProps } from '../../../typings';

import { apiConfig } from '../config';
import { postFetch } from '../fetch';

export function postBulkUserProps(params: PostBodyUserProps) {
    const { apiBulkAddOrUpdateUserProps } = apiConfig.getStaticUrls();

    return postFetch(apiBulkAddOrUpdateUserProps, params);
}
